import Swiper from "swiper";
var Mustache = require("mustache");
import swiperA11y from "../utils/swiperA11y";
import config from "../utils/config";

const milestone = function () {
  try {
    if ($(".milestone").length) {
      milestoneInit();
    }
  } catch (e) {
    console.log(e);
  }
};

const milestoneInit = function () {
  const swiper = new Swiper(".milestone .swiper-container", {
    // Optional parameters
    loop: false,
    autoHeight: false,
    grabCursor: true,
    keyboardControl: true,
    centeredSlides: false,
    watchSlidesVisibility: true,
    // If we need pagination
    pagination: {
      el: ".milestone .swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    navigation: {
      nextEl: ".milestone .swiper-button-next",
      prevEl: ".milestone .swiper-button-prev",
    },
    slideVisibleClass: "swiper-slide-visible",
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
      // when window width is >= 992px
      992: {
        slidesPerView: 3.025,
        spaceBetween: 25,
      },
    },
    init: false,
    // on: {
    //   init: function () {
    //     swiperA11y.toggleAriaHidden(swiper, false);
    //   },
    // },
    a11y: {
      paginationBulletMessage:
        document.documentElement.lang == "en"
          ? "Go to slide {{index}}"
          : "前往第{{index}}頁",
    },
  });
  swiper.init();

  swiper.on("transitionStart", function () {
    swiperA11y.toggleAriaHidden(swiper, false);
  });

  $(document).ready(function () {
    $(".milestone__slide button, .milestone__slide a")
      .on("focus", function (e) {
        swiper.autoplay.stop();
      })
      .on("blur", function () {
        swiper.autoplay.start();
      });
    if ($(".page--esg").length === 0) {
      $(".milestone__slide:odd .milestone__line").addClass(
        "milestone__line--long"
      );
    } else {
      syncHeight(".milestone__title");
      syncHeight(".milestone__desc");
    }
  });

  function syncHeight(el, mode) {
    if (mode == "resize") {
      $(el).height("auto");
    }
    let height = 0;
    $(el).each(function () {
      height = Math.max($(this).outerHeight(), height);
    });
    $(el).height(function () {
      return height;
    });
  }

  $(window).resize(function () {
    syncHeight(".milestone__title", "resize");
    syncHeight(".milestone__desc", "resize");
  });
};

export default milestone;
